export class ListInventorySourceRegionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<CloudRegion>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListInventorySourceRegionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
